import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import InfoIcon from "@material-ui/icons/Info";
import QuestionContainer from "../../containers/settings/QuestionContainer";
import DeleteQuestionContainer from "../../containers/settings/DeleteQuestionContainer";
import ProductContainer from "../../containers/settings/ProductContainer";
import DeleteProductContainer from "../../containers/settings/DeleteProductContainer";
import SignupEmailTexts from "../../constants/SignupEmailTexts";
import SignupNameQuestion from "../../constants/SignupNameQuestion";
import { Tooltip } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Currencies from "../../constants/Currencies";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import HelpIcon from "@material-ui/icons/HelpOutline";

export default class SignupSettings extends React.Component {
  render() {
    return (
      <div style={{ width: "100%", paddingTop: 35, paddingBottom: 50 }}>
        <div style={{ width: 650, maxWidth: "97%", margin: "auto" }}>
          <Button
            onClick={(e) => {
              this.props.handleBack();
            }}
            variant="text"
            size="small"
            style={{ marginBottom: 15 }}
          >
            <ArrowBackIcon style={{ height: 18 }} />
            <span>{languages.general.back}</span>
          </Button>
          <Typography variant="h6">
            {languages.signupPage.signupPage}
          </Typography>
          <Typography variant="caption" style={{ marginBottom: 20 }}>
            {languages.formatString(
              languages.signupPage.signupPageDescription,
              this.props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ marginBottom: 10, marginTop: 20 }}
          >
            {languages.signupPage.status}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={this.props.tournament.signupOpen || false}
                onChange={this.props.handleOpenSignupChange}
                color="primary"
                name="signupOpen"
              />
            }
            label={
              this.props.tournament.signupOpen || false
                ? languages.signupPage.signupOpen
                : languages.signupPage.signupClosed
            }
          />
          <Typography variant="subtitle2" style={{ marginTop: 20 }}>
            {languages.signupPage.description}
          </Typography>
          <Typography variant="caption" style={{ marginBottom: 10 }}>
            {languages.signupPage.descriptionInfo}
          </Typography>
          <div style={{ display: "flex", marginTop: 15 }}>
            {(this.props.tournament.lang || []).length > 1 && (
              <div
                style={{
                  borderRight: "1px solid lightgray",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Button
                  onClick={(e) => {
                    this.props.handleDescriptionTrChange(null);
                  }}
                  variant="text"
                  size="small"
                  style={{ fontWeight: this.props.tr === null ? 500 : 300 }}
                >
                  {(this.props.tournament.lang || [])[0]}
                </Button>
                {(this.props.tournament.lang || []).slice(1).map((lang) => {
                  return (
                    <Button
                      key={lang}
                      onClick={(e) => {
                        this.props.handleDescriptionTrChange(lang);
                      }}
                      variant="text"
                      size="small"
                      style={{ fontWeight: this.props.tr === lang ? 500 : 300 }}
                    >
                      {lang}
                    </Button>
                  );
                })}
              </div>
            )}
            <div
              style={{
                width: "100%",
                padding:
                  "10px 0 0 " +
                  ((this.props.tournament.lang || []).length > 1
                    ? "20px"
                    : "0"),
              }}
            >
              <TextField
                onClick={() => {
                  this.props.toggleDescriptionDialog(this.props.tr);
                }}
                multiline
                rows="7"
                fullWidth
                name="signupDescription"
                value={(
                  this.props.tournament[
                    "signupDescription" + (this.props.tr ? this.props.tr : "")
                  ] || ""
                ).replace(/<br \/>/g, "\n")}
              />
            </div>
          </div>
          <Typography
            variant="subtitle2"
            style={{ marginTop: 30, marginBottom: 10 }}
          >
            {languages.signupPage.maxSignups}
          </Typography>
          <TextField
            fullWidth
            // label={languages.signupPage.total}
            name="totalSignups"
            value={this.props.tournament.totalSignups || ""}
            onChange={this.props.handleTotalSignupsChange}
          />
          {this.props.divisions.length > 1 && (
            <Typography variant="subtitle2" style={{ marginTop: 30 }}>
              {languages.signupPage.maxSignupsDivision}
            </Typography>
          )}
          {this.props.divisions.length > 1 && (
            <Grid
              container
              spacing={2}
              alignItems="flex-start"
              style={{ marginTop: 10 }}
            >
              {this.props.divisions
                .sort((a, b) => a.id - b.id)
                .map((division, i) => (
                  <Grid key={i} item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      fullWidth
                      label={division.name}
                      name={division.id}
                      value={
                        (this.props.tournament.divisionSignups || {})[
                          division.id
                        ] || ""
                      }
                      onChange={this.props.handleDivisionSignupsChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                ))}
            </Grid>
          )}
          <div style={{ marginTop: 10 }}>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  name="sendCopy"
                  checked={
                    (this.props.tournament.allowMultipleSignups === undefined ||
                      this.props.tournament.allowMultipleSignups ||
                      false) &&
                    !this.props.tournament.listIdAC
                  }
                  onChange={this.props.handleAllowMultipleSignupsChange}
                  disabled={
                    this.props.tournament.listIdAC !== undefined &&
                    this.props.tournament.listIdAC !== ""
                  }
                />
              }
              label={languages.formatString(
                languages.signupPage.allowMultipleSignups,
                this.props.tournament.individualPlayers
                  ? languages.teams.playersLow
                  : languages.tournament.teamsLow
              )}
            />
          </div>
          <Typography
            variant="subtitle2"
            style={{
              marginTop: 30,
            }}
          >
            {languages.signupPage.signupPrice}
          </Typography>
          <Typography variant="caption" style={{ marginBottom: 10 }}>
            {languages.formatString(
              languages.signupPage.SignupPriceDescription,
              this.props.tournament.individualPlayers
                ? languages.teams.playerLow
                : languages.results.teamLow
            )}
          </Typography>
          {this.props.divisions.length > 1 && (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.props.tournament.pricePerDivision || false}
                    onChange={this.props.handlePricePerDivisionCheck}
                    color="primary"
                  />
                }
                label={languages.signupPage.perDivision}
              />
            </div>
          )}

          {this.props.divisions.length > 1 &&
          (this.props.tournament.pricePerDivision || false) ? (
            <Grid container spacing={2} alignItems="flex-start">
              {this.props.divisions
                .sort((a, b) => a.id - b.id)
                .map((division, i) => (
                  <Grid key={i} item xs={12} sm={6} md={6} lg={6}>
                    <div style={{ display: "flex", alignItems: "flex-end" }}>
                      <Select
                        value={this.props.tournament.currency || "EUR"}
                        onChange={this.props.handleCurrencyChange}
                        style={{ marginRight: 10 }}
                      >
                        {Object.keys(Currencies).map((item, i) => {
                          return (
                            <MenuItem
                              key={i}
                              value={Currencies[item].code}
                              divider={i === 11}
                            >
                              {Currencies[item].code + " "}
                              <span
                                style={{ marginLeft: "auto", color: "#BDBDBD" }}
                              >
                                {Currencies[item].symbol}
                              </span>
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <TextField
                        fullWidth
                        placeholder="0"
                        label={division.name}
                        name={division.id}
                        value={
                          (this.props.tournament.divisionSignupPrice || {})[
                            division.id
                          ] || ""
                        }
                        onChange={this.props.handleDivisionSignupPriceChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                  </Grid>
                ))}
            </Grid>
          ) : (
            <div style={{ display: "flex" }}>
              <Select
                value={this.props.tournament.currency || "EUR"}
                onChange={this.props.handleCurrencyChange}
                style={{ marginRight: 10 }}
              >
                {Object.keys(Currencies).map((item, i) => {
                  return (
                    <MenuItem
                      key={i}
                      value={Currencies[item].code}
                      divider={i === 10}
                    >
                      {Currencies[item].code + " "}
                      <span style={{ marginLeft: "auto", color: "#BDBDBD" }}>
                        {Currencies[item].symbol}
                      </span>
                    </MenuItem>
                  );
                })}
              </Select>
              <TextField
                fullWidth
                placeholder="0"
                name="signupPrice"
                value={this.props.tournament.signupPrice || ""}
                onChange={this.props.handleSignupPriceChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          )}
          <Typography variant="subtitle2" style={{ marginTop: 30 }}>
            {languages.signupPage.paymentMethods}
          </Typography>
          <Typography variant="caption" style={{ marginBottom: 10 }}>
            {languages.signupPage.paymentMethodsDescription}
          </Typography>

          <div style={{ marginTop: 10 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.tournament.onlinePayment || false}
                  onChange={this.props.handlePaymentMethodChange}
                  disabled={
                    this.props.tournament.currency &&
                    !Currencies[this.props.tournament.currency].mollie
                  }
                  color="primary"
                  name="onlinePayment"
                />
              }
              label={languages.signupPage.onlinePayment}
            />
          </div>

          {(this.props.tournament.onlinePayment || false) &&
            !this.props.tournamentAdmin && (
              <Button
                onClick={(e) => {
                  this.props.toggleMollieConnectDialog();
                }}
                variant="outlined"
                size="small"
              >
                <span>{languages.signupPage.mollieConnect}</span>
              </Button>
            )}

          <div>
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.tournament.manualPayment || false}
                  onChange={this.props.handlePaymentMethodChange}
                  color="primary"
                  name="manualPayment"
                />
              }
              label={languages.signupPage.manualPayment}
            />
          </div>
          {(this.props.tournament.manualPayment || false) && (
            <div style={{ display: "flex" }}>
              {(this.props.tournament.lang || []).length > 1 && (
                <div
                  style={{
                    borderRight: "1px solid lightgray",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Button
                    onClick={(e) => {
                      this.props.handlePaymentTrChange(null);
                    }}
                    variant="text"
                    size="small"
                    style={{
                      fontWeight: this.props.trPayment === null ? 500 : 300,
                    }}
                  >
                    {(this.props.tournament.lang || [])[0]}
                  </Button>
                  {(this.props.tournament.lang || []).slice(1).map((lang) => {
                    return (
                      <Button
                        key={lang}
                        onClick={(e) => {
                          this.props.handlePaymentTrChange(lang);
                        }}
                        variant="text"
                        size="small"
                        style={{
                          fontWeight: this.props.trPayment === lang ? 500 : 300,
                        }}
                      >
                        {lang}
                      </Button>
                    );
                  })}
                </div>
              )}
              <div
                style={{
                  width: "100%",
                  padding:
                    "10px 0 0 " +
                    ((this.props.tournament.lang || []).length > 1
                      ? "20px"
                      : "0"),
                }}
              >
                <TextField
                  style={{ marginBottom: 10 }}
                  onClick={this.props.togglePaymentInstructionsDialog}
                  multiline
                  rowsMax="4"
                  fullWidth
                  name="paymentInstructions"
                  value={(
                    this.props.tournament[
                      "paymentInstructions" +
                        (this.props.trPayment ? this.props.trPayment : "")
                    ] || ""
                  ).replace(/<br \/>/g, "\n")}
                />
              </div>
            </div>
          )}
          <div>
            <FormControlLabel
              control={
                <Switch
                  checked={this.props.tournament.manualPayment2 || false}
                  onChange={this.props.handlePaymentMethodChange}
                  color="primary"
                  name="manualPayment2"
                />
              }
              label={languages.signupPage.manualPayment2}
            />
          </div>
          {(this.props.tournament.manualPayment2 || false) && (
            <div style={{ display: "flex" }}>
              {(this.props.tournament.lang || []).length > 1 && (
                <div
                  style={{
                    borderRight: "1px solid lightgray",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Button
                    onClick={(e) => {
                      this.props.handlePayment2TrChange(null);
                    }}
                    variant="text"
                    size="small"
                    style={{
                      fontWeight: this.props.trPayment2 === null ? 500 : 300,
                    }}
                  >
                    {(this.props.tournament.lang || [])[0]}
                  </Button>
                  {(this.props.tournament.lang || []).slice(1).map((lang) => {
                    return (
                      <Button
                        key={lang}
                        onClick={(e) => {
                          this.props.handlePayment2TrChange(lang);
                        }}
                        variant="text"
                        size="small"
                        style={{
                          fontWeight:
                            this.props.trPayment2 === lang ? 500 : 300,
                        }}
                      >
                        {lang}
                      </Button>
                    );
                  })}
                </div>
              )}
              <div
                style={{
                  width: "100%",
                  padding:
                    "10px 0 0 " +
                    ((this.props.tournament.lang || []).length > 1
                      ? "20px"
                      : "0"),
                }}
              >
                <TextField
                  style={{ marginBottom: 10 }}
                  onClick={this.props.togglePaymentInstructions2Dialog}
                  multiline
                  rowsMax="4"
                  fullWidth
                  name="paymentInstructions2"
                  value={(
                    this.props.tournament[
                      "paymentInstructions2" +
                        (this.props.trPayment2 ? this.props.trPayment2 : "")
                    ] || ""
                  ).replace(/<br \/>/g, "\n")}
                />
              </div>
            </div>
          )}

          <Typography variant="subtitle2" style={{ marginTop: 30 }}>
            {languages.signupPage.signupForm}
          </Typography>
          <div style={{ marginBottom: 10 }}>
            <Typography variant="caption">
              {languages.formatString(
                languages.signupPage.signupFormDescription,
                this.props.tournament.individualPlayers
                  ? languages.teams.playerLow
                  : languages.results.teamLow
              )}
            </Typography>
          </div>

          {this.props.divisions.length > 1 && (
            <div style={{ paddingBottom: 3 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  border: "1px solid lightgray",
                  padding: 5,
                  alignItems: "center",
                  borderRadius: 5,
                }}
              >
                <Typography>
                  {this.props.tournament.divisionSignupQuestion ||
                    (this.props.tournament.individualPlayers
                      ? SignupNameQuestion.playerDivisionQuestion[
                          (this.props.tournament.lang || [])[0]
                            ? (this.props.tournament.lang || [])[0]
                            : languages.getLanguage()
                        ]
                      : SignupNameQuestion.teamDivisionQuestion[
                          (this.props.tournament.lang || [])[0]
                            ? (this.props.tournament.lang || [])[0]
                            : languages.getLanguage()
                        ])}
                </Typography>
                <div style={{ display: "flex" }}>
                  <QuestionContainer
                    tournament={this.props.tournament}
                    question={
                      this.props.tournament.divisionSignupQuestion
                        ? {
                            name: this.props.tournament.divisionSignupQuestion,
                            trs: this.props.tournament
                              .trsDivisionSignupQuestion,
                            id: "4",
                          }
                        : {
                            name: this.props.tournament.individualPlayers
                              ? SignupNameQuestion.playerDivisionQuestion[
                                  (this.props.tournament.lang || [])[0]
                                    ? (this.props.tournament.lang || [])[0]
                                    : languages.getLanguage()
                                ]
                              : SignupNameQuestion.teamDivisionQuestion[
                                  (this.props.tournament.lang || [])[0]
                                    ? (this.props.tournament.lang || [])[0]
                                    : languages.getLanguage()
                                ],
                            trs: this.props.tournament.individualPlayers
                              ? SignupNameQuestion.playerDivisionQuestion
                              : SignupNameQuestion.teamDivisionQuestion,
                            id: "4",
                          }
                    }
                  />

                  <FormControlLabel
                    style={{ marginLeft: -6, marginRight: 0 }}
                    control={
                      <Tooltip title={languages.present.show} placement="top">
                        <Checkbox
                          disabled
                          checked={true}
                          color="primary"
                          style={{ padding: "0px 9px" }}
                        />
                      </Tooltip>
                    }
                  />
                </div>
              </div>
            </div>
          )}

          <div style={{ paddingBottom: 3 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                border: "1px solid lightgray",
                padding: 5,
                alignItems: "center",
                borderRadius: 5,
              }}
            >
              <Typography>
                {this.props.tournament.teamSignupQuestion ||
                  (this.props.tournament.individualPlayers
                    ? SignupNameQuestion.playerNameQuestion[
                        (this.props.tournament.lang || [])[0]
                          ? (this.props.tournament.lang || [])[0]
                          : languages.getLanguage()
                      ]
                    : SignupNameQuestion.teamNameQuestion[
                        (this.props.tournament.lang || [])[0]
                          ? (this.props.tournament.lang || [])[0]
                          : languages.getLanguage()
                      ])}
              </Typography>
              <div style={{ display: "flex" }}>
                <QuestionContainer
                  tournament={this.props.tournament}
                  question={
                    this.props.tournament.teamSignupQuestion
                      ? {
                          name: this.props.tournament.teamSignupQuestion,
                          trs: this.props.tournament.trsTeamSignupQuestion,
                          id: "0",
                        }
                      : {
                          name: this.props.tournament.individualPlayers
                            ? SignupNameQuestion.playerNameQuestion[
                                (this.props.tournament.lang || [])[0]
                                  ? (this.props.tournament.lang || [])[0]
                                  : languages.getLanguage()
                              ]
                            : SignupNameQuestion.teamNameQuestion[
                                (this.props.tournament.lang || [])[0]
                                  ? (this.props.tournament.lang || [])[0]
                                  : languages.getLanguage()
                              ],
                          trs: this.props.tournament.individualPlayers
                            ? SignupNameQuestion.playerNameQuestion
                            : SignupNameQuestion.teamNameQuestion,
                          id: "0",
                        }
                  }
                />

                <FormControlLabel
                  style={{ marginLeft: -6, marginRight: 0 }}
                  control={
                    <Tooltip title={languages.present.show} placement="top">
                      <Checkbox
                        disabled
                        checked={true}
                        color="primary"
                        style={{ padding: "0px 9px" }}
                      />
                    </Tooltip>
                  }
                />
              </div>
            </div>
          </div>

          {(((this.props.tournament.defaultFields || {})["logo"] || {}).show ||
            (this.props.tournament.defaultFields || {})["logo"] ===
              undefined) && (
            <div style={{ paddingBottom: 3 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  border: "1px solid lightgray",
                  padding: 5,
                  alignItems: "center",
                  borderRadius: 5,
                }}
              >
                <Typography>{languages.signupPage.logoQuestion}</Typography>
                <div style={{ display: "flex" }}>
                  <IconButton
                    aria-label="Change"
                    disabled
                    style={{ height: 30, width: 30 }}
                  >
                    <CreateIcon
                      style={{
                        height: 20,
                        width: 20,
                        position: "absolute",
                        top: 5,
                      }}
                    />
                  </IconButton>

                  <FormControlLabel
                    style={{ marginLeft: -6, marginRight: 0 }}
                    control={
                      <Tooltip title={languages.present.show} placement="top">
                        <Checkbox
                          checked={
                            this.props.tournament.showLogoSignupQuestion ||
                            false
                          }
                          onChange={
                            this.props.handleShowLogoSignupQuestionCheck
                          }
                          color="primary"
                          style={{ padding: "0px 9px" }}
                        />
                      </Tooltip>
                    }
                  />
                </div>
              </div>
            </div>
          )}

          {this.props.tournament.online && (
            <div style={{ paddingBottom: 3 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  border: "1px solid lightgray",
                  padding: 5,
                  alignItems: "center",
                  borderRadius: 5,
                }}
              >
                <Typography>
                  {this.props.tournament.teamSignupQuestion2 ||
                    SignupNameQuestion.gamertagQuestion[
                      (this.props.tournament.lang || [])[0]
                        ? (this.props.tournament.lang || [])[0]
                        : languages.getLanguage()
                    ]}
                </Typography>
                <div style={{ display: "flex" }}>
                  <QuestionContainer
                    tournament={this.props.tournament}
                    question={
                      this.props.tournament.teamSignupQuestion2
                        ? {
                            name: this.props.tournament.teamSignupQuestion2,
                            trs: this.props.tournament.trsTeamSignupQuestion2,
                            id: "1",
                          }
                        : {
                            name: SignupNameQuestion.gamertagQuestion[
                              (this.props.tournament.lang || [])[0]
                                ? (this.props.tournament.lang || [])[0]
                                : languages.getLanguage()
                            ],
                            trs: SignupNameQuestion.gamertagQuestion,
                            id: "1",
                          }
                    }
                  />

                  <FormControlLabel
                    style={{ marginLeft: -6, marginRight: 0 }}
                    control={
                      <Tooltip title={languages.present.show} placement="top">
                        <Checkbox
                          checked={
                            this.props.tournament.showTeamSignupQuestion2 ||
                            false
                          }
                          onChange={this.props.handleTeamSignupQuestion2Check}
                          color="primary"
                          style={{ padding: "0px 9px" }}
                        />
                      </Tooltip>
                    }
                  />
                </div>
              </div>
            </div>
          )}

          {(((this.props.tournament.defaultFields || {})["players"] || {})
            .show ||
            (this.props.tournament.defaultFields || {})["players"] ===
              undefined) && (
            <div style={{ paddingBottom: 3 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  border: "1px solid lightgray",
                  padding: 5,
                  alignItems: "center",
                  borderRadius: 5,
                }}
              >
                <Typography>
                  {this.props.tournament.individualPlayersSignupQuestion ||
                    SignupNameQuestion.individualPlayersQuestion[
                      (this.props.tournament.lang || [])[0]
                        ? (this.props.tournament.lang || [])[0]
                        : languages.getLanguage()
                    ]}
                  <Tooltip title={languages.tournament.addPlayerColumnsTooltip}>
                    <HelpIcon
                      style={{
                        height: 15,
                        width: 15,
                        position: "relative",
                        top: 2,
                        marginLeft: 5,
                      }}
                    />
                  </Tooltip>
                </Typography>

                <div style={{ display: "flex" }}>
                  <QuestionContainer
                    tournament={this.props.tournament}
                    question={
                      this.props.tournament.individualPlayersSignupQuestion
                        ? {
                            name: this.props.tournament
                              .individualPlayersSignupQuestion,
                            trs: this.props.tournament
                              .trsIndividualPlayersSignupQuestion,
                            id: "2",
                          }
                        : {
                            name: SignupNameQuestion.individualPlayersQuestion[
                              (this.props.tournament.lang || [])[0]
                                ? (this.props.tournament.lang || [])[0]
                                : languages.getLanguage()
                            ],
                            trs: SignupNameQuestion.individualPlayersQuestion,
                            id: "2",
                          }
                    }
                  />
                  <FormControlLabel
                    style={{ marginLeft: -6, marginRight: 0 }}
                    control={
                      <Tooltip title={languages.present.show} placement="top">
                        <Checkbox
                          checked={
                            this.props.tournament
                              .showIndividualPlayersSignupQuestion || false
                          }
                          onChange={
                            this.props.handleIndividualPlayersQuestionCheck
                          }
                          color="primary"
                          style={{ padding: "0px 9px" }}
                        />
                      </Tooltip>
                    }
                  />
                </div>
              </div>
            </div>
          )}

          {((this.props.tournament.defaultFields || {})["country"] || {})
            .show && (
            <div style={{ paddingBottom: 3 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  border: "1px solid lightgray",
                  padding: 5,
                  alignItems: "center",
                  borderRadius: 5,
                }}
              >
                <Typography>
                  {this.props.tournament.countrySignupQuestion ||
                    (this.props.tournament.individualPlayers
                      ? SignupNameQuestion.playerCountryQuestion[
                          (this.props.tournament.lang || [])[0]
                            ? (this.props.tournament.lang || [])[0]
                            : languages.getLanguage()
                        ]
                      : SignupNameQuestion.teamCountryQuestion[
                          (this.props.tournament.lang || [])[0]
                            ? (this.props.tournament.lang || [])[0]
                            : languages.getLanguage()
                        ])}
                </Typography>
                <div style={{ display: "flex" }}>
                  <QuestionContainer
                    tournament={this.props.tournament}
                    question={
                      this.props.tournament.countrySignupQuestion
                        ? {
                            name: this.props.tournament.countrySignupQuestion,
                            trs: this.props.tournament.trsCountrySignupQuestion,
                            id: "3",
                          }
                        : {
                            name: this.props.tournament.individualPlayers
                              ? SignupNameQuestion.playerCountryQuestion[
                                  (this.props.tournament.lang || [])[0]
                                    ? (this.props.tournament.lang || [])[0]
                                    : languages.getLanguage()
                                ]
                              : SignupNameQuestion.teamCountryQuestion[
                                  (this.props.tournament.lang || [])[0]
                                    ? (this.props.tournament.lang || [])[0]
                                    : languages.getLanguage()
                                ],
                            trs: this.props.tournament.individualPlayers
                              ? SignupNameQuestion.playerCountryQuestion
                              : SignupNameQuestion.teamCountryQuestion,
                            id: "3",
                          }
                    }
                  />

                  <FormControlLabel
                    style={{ marginLeft: -6, marginRight: 0 }}
                    control={
                      <Tooltip title={languages.present.show} placement="top">
                        <Checkbox
                          checked={
                            this.props.tournament.showCountrySignupQuestion ||
                            false
                          }
                          onChange={
                            this.props.handleShowCountrySignupQuestionCheck
                          }
                          color="primary"
                          style={{ padding: "0px 9px" }}
                        />
                      </Tooltip>
                    }
                  />
                </div>
              </div>
            </div>
          )}
          {Object.keys(this.props.tournament.questions || {}).filter(
            (key) => this.props.tournament.questions[key].perSignup !== true
          ).length > 0 && (
            <div>
              <div style={{ marginTop: 10 }}>
                <Typography variant="caption" style={{ fontWeight: 500 }}>
                  {languages.formatString(
                    languages.signupPage.perTeam,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow
                  )}
                </Typography>
              </div>
              <DragDropContext
                onDragEnd={(result) => this.props.onDragEnd(result, false)}
              >
                <Droppable droppableId="questionPerTeamDrop">
                  {(provided, snapshot) => {
                    return (
                      <div
                        ref={provided.innerRef}
                        style={{
                          marginTop: 5,
                        }}
                      >
                        {Object.keys(this.props.tournament.questions || {})
                          .filter(
                            (key) =>
                              this.props.tournament.questions[key].perSignup !==
                              true
                          )
                          .sort((a, b) => {
                            const qA = this.props.tournament.questions[a];
                            const qB = this.props.tournament.questions[b];
                            if (qA.num > qB.num) {
                              return 1;
                            } else if (qA.num < qB.num) {
                              return -1;
                            } else {
                              return 0;
                            }
                          })
                          .map((key, i) => {
                            const question = Object.assign(
                              {},
                              this.props.tournament.questions[key]
                            );
                            question["id"] = key;
                            return (
                              <Draggable key={key} draggableId={key} index={i}>
                                {(provided, snapshot) => (
                                  <div>
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div style={{ paddingBottom: 3 }}>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            border: "1px solid lightgray",
                                            padding: 5,
                                            alignItems: "center",
                                            borderRadius: 5,
                                            background: "white",
                                          }}
                                        >
                                          <Typography>
                                            {question.name}
                                          </Typography>
                                          <div style={{ display: "flex" }}>
                                            <QuestionContainer
                                              tournament={this.props.tournament}
                                              question={question}
                                            />
                                            <DeleteQuestionContainer
                                              tournament={this.props.tournament}
                                              questionId={key}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}
                        {provided.placeholder}
                      </div>
                    );
                  }}
                </Droppable>
              </DragDropContext>
            </div>
          )}

          {Object.keys(this.props.tournament.questions || {}).filter(
            (key) => this.props.tournament.questions[key].perSignup === true
          ).length > 0 && (
            <div>
              <div style={{ marginTop: 10 }}>
                <Typography variant="caption" style={{ fontWeight: 500 }}>
                  {languages.signupPage.perSignup}
                </Typography>
              </div>
              <DragDropContext
                onDragEnd={(result) => this.props.onDragEnd(result, true)}
              >
                <Droppable droppableId="questionPerSignupDrop">
                  {(provided, snapshot) => {
                    return (
                      <div
                        ref={provided.innerRef}
                        style={{
                          marginTop: 5,
                        }}
                      >
                        {Object.keys(this.props.tournament.questions || {})
                          .filter(
                            (key) =>
                              this.props.tournament.questions[key].perSignup ===
                              true
                          )
                          .sort((a, b) => {
                            const qA = this.props.tournament.questions[a];
                            const qB = this.props.tournament.questions[b];
                            if (qA.num > qB.num) {
                              return 1;
                            } else if (qA.num < qB.num) {
                              return -1;
                            } else {
                              return 0;
                            }
                          })
                          .map((key, i) => {
                            const question = Object.assign(
                              {},
                              this.props.tournament.questions[key]
                            );
                            question["id"] = key;
                            return (
                              <Draggable key={key} draggableId={key} index={i}>
                                {(provided, snapshot) => (
                                  <div>
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div style={{ paddingBottom: 3 }}>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            border: "1px solid lightgray",
                                            padding: 5,
                                            alignItems: "center",
                                            borderRadius: 5,
                                            background: "white",
                                          }}
                                        >
                                          <Typography>
                                            {question.name}
                                          </Typography>
                                          <div style={{ display: "flex" }}>
                                            <QuestionContainer
                                              tournament={this.props.tournament}
                                              question={question}
                                            />
                                            <DeleteQuestionContainer
                                              tournament={this.props.tournament}
                                              questionId={key}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}
                        {provided.placeholder}
                      </div>
                    );
                  }}
                </Droppable>
              </DragDropContext>
            </div>
          )}
          <QuestionContainer tournament={this.props.tournament} />
          <Typography variant="subtitle2" style={{ marginTop: 30 }}>
            {languages.signupPage.extraProducts}
          </Typography>
          <Typography variant="caption" style={{ marginBottom: 10 }}>
            {languages.signupPage.extraProductsDescription}
          </Typography>
          <DragDropContext
            onDragEnd={(result) => this.props.onDragEndProduct(result)}
          >
            <Droppable droppableId="productDrop">
              {(provided, snapshot) => {
                return (
                  <div
                    ref={provided.innerRef}
                    style={{
                      marginTop: 5,
                      marginBottom:
                        Object.keys(this.props.tournament.products || {})
                          .length === 0
                          ? 5
                          : 0,
                    }}
                  >
                    {Object.keys(this.props.tournament.products || {})
                      .sort((a, b) => {
                        const pA = this.props.tournament.products[a];
                        const pB = this.props.tournament.products[b];
                        if (pA.num > pB.num) {
                          return 1;
                        } else if (pA.num < pB.num) {
                          return -1;
                        } else {
                          return 0;
                        }
                      })
                      .map((key, i) => {
                        const product = Object.assign(
                          {},
                          this.props.tournament.products[key]
                        );
                        product["id"] = key;
                        return (
                          <Draggable key={key} draggableId={key} index={i}>
                            {(provided, snapshot) => (
                              <div>
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <div style={{ paddingBottom: 3 }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        border: "1px solid lightgray",
                                        padding: 5,
                                        alignItems: "center",
                                        borderRadius: 5,
                                        background: "white",
                                      }}
                                    >
                                      <Typography>{product.name}</Typography>
                                      <div style={{ display: "flex" }}>
                                        <ProductContainer
                                          tournament={this.props.tournament}
                                          product={product}
                                        />
                                        <DeleteProductContainer
                                          tournament={this.props.tournament}
                                          productId={key}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {provided.placeholder}
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>

          <ProductContainer tournament={this.props.tournament} />

          <Typography variant="subtitle2" style={{ marginTop: 30 }}>
            {languages.signupPage.confirmationEmail}
          </Typography>
          <Typography variant="caption">
            {languages.formatString(
              languages.signupPage.confirmationEmailDescription,
              this.props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
          </Typography>

          <div style={{ marginTop: 10 }}>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  name="sendCopy"
                  checked={
                    this.props.tournament.sendSignupConfirmationEmail ===
                      undefined ||
                    this.props.tournament.sendSignupConfirmationEmail ||
                    false
                  }
                  onChange={this.props.handleSendConfirmationChange}
                />
              }
              label={languages.signupPage.sendConfirmationEmail}
            />
          </div>

          <div style={{ display: "flex", marginTop: 15 }}>
            {(this.props.tournament.lang || []).length > 1 && (
              <div
                style={{
                  borderRight: "1px solid lightgray",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Button
                  onClick={(e) => {
                    this.props.handleEmailTextsTrChange(null);
                  }}
                  variant="text"
                  size="small"
                  style={{
                    fontWeight: this.props.trEmailTexts === null ? 500 : 300,
                  }}
                >
                  {(this.props.tournament.lang || [])[0]}
                </Button>
                {(this.props.tournament.lang || []).slice(1).map((lang) => {
                  return (
                    <Button
                      key={lang}
                      onClick={(e) => {
                        this.props.handleEmailTextsTrChange(lang);
                      }}
                      variant="text"
                      size="small"
                      style={{
                        fontWeight:
                          this.props.trEmailTexts === lang ? 500 : 300,
                      }}
                    >
                      {lang}
                    </Button>
                  );
                })}
              </div>
            )}
            <div
              style={{
                width: "100%",
                padding:
                  "10px 0 0 " +
                  ((this.props.tournament.lang || []).length > 1
                    ? "20px"
                    : "0"),
              }}
            >
              <TextField
                fullWidth
                label={languages.signupPage.confirmationEmailSubject}
                name="emailSubject"
                value={
                  this.props.emailTexts[
                    "emailSubject" +
                      (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                  ] ||
                  SignupEmailTexts.confirmationEmailSubjectText[
                    (this.props.tournament.lang || [])[
                      this.props.trEmailTexts
                        ? (this.props.tournament.lang || []).indexOf(
                            this.props.trEmailTexts
                          )
                        : 0
                    ]
                      ? (this.props.tournament.lang || [])[
                          this.props.trEmailTexts
                            ? (this.props.tournament.lang || []).indexOf(
                                this.props.trEmailTexts
                              )
                            : 0
                        ]
                      : languages.getLanguage()
                  ]
                }
                type="text"
                style={{ marginBottom: 20, marginTop: 10 }}
                onClick={this.props.toggleEmailTextsDialog}
              />

              <TextField
                fullWidth
                id="textarea"
                label={languages.signupPage.confirmationEmailStart}
                name="emailStart"
                multiline
                style={{ marginBottom: 20 }}
                onClick={this.props.toggleEmailTextsDialog}
                value={
                  (
                    this.props.emailTexts[
                      "emailStart" +
                        (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                    ] || ""
                  ).replace(/<br \/>/g, "\n") ||
                  SignupEmailTexts.confirmationEmailStartText[
                    (this.props.tournament.lang || [])[
                      this.props.trEmailTexts
                        ? (this.props.tournament.lang || []).indexOf(
                            this.props.trEmailTexts
                          )
                        : 0
                    ]
                      ? (this.props.tournament.lang || [])[
                          this.props.trEmailTexts
                            ? (this.props.tournament.lang || []).indexOf(
                                this.props.trEmailTexts
                              )
                            : 0
                        ]
                      : languages.getLanguage()
                  ]
                }
              />

              <Typography
                style={{
                  background: "rgb(236, 239, 241)",
                  padding: 10,
                  borderRadius: 5,
                  marginTop: 10,
                  marginBottom: 20,
                }}
              >
                <InfoIcon style={{ height: 15, width: 15 }} />
                {" " + languages.signupPage.confirmationEmailInfo}
              </Typography>

              <TextField
                fullWidth
                id="textarea"
                label={languages.signupPage.confirmationEmailEnd}
                name="emailEnd"
                multiline
                value={
                  (
                    this.props.emailTexts[
                      "emailEnd" +
                        (this.props.trEmailTexts ? this.props.trEmailTexts : "")
                    ] || ""
                  ).replace(/<br \/>/g, "\n") ||
                  SignupEmailTexts.confirmationEmailEndText[
                    (this.props.tournament.lang || [])[
                      this.props.trEmailTexts
                        ? (this.props.tournament.lang || []).indexOf(
                            this.props.trEmailTexts
                          )
                        : 0
                    ]
                      ? (this.props.tournament.lang || [])[
                          this.props.trEmailTexts
                            ? (this.props.tournament.lang || []).indexOf(
                                this.props.trEmailTexts
                              )
                            : 0
                        ]
                      : languages.getLanguage()
                  ]
                }
                onClick={this.props.toggleEmailTextsDialog}
              />
            </div>
          </div>
          <br />
          <br />
          <FormControlLabel
            control={
              <Switch
                color="primary"
                name="sendCopy"
                checked={this.props.tournament.sendCopy || false}
                onChange={this.props.handleSendCopyChange}
              />
            }
            label={languages.signupPage.confirmationEmailCopy}
          />
          {this.props.tournament.sendCopy && (
            <div>
              <TextField
                fullWidth
                type="email"
                name="emailCopy"
                label={languages.login.email}
                value={this.props.emailCopy}
                onClick={this.props.toggleEmailCopyDialog}
              />
            </div>
          )}
          <br />
          <br />
          <FormControlLabel
            control={
              <Switch
                checked={this.props.tournament.addLoginLink || false}
                onChange={this.props.handleAddLoginLinkChange}
                color="primary"
                name="addLoginLink"
              />
            }
            label={languages.formatString(
              languages.signupPage.addLoginLink,
              this.props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
          />

          {(this.props.tournament.uid === "UiIJajZgHLPImDX1VIBmezMtUtU2" || // Weplay
            this.props.tournament.uid === "dLIIgYris4QH9SaFvO1fYkfWhSw2" || // Jesse
            this.props.tournament.uid === "qwVXeKNiBzMz3RyUJSAJFLrkFnH2") &&
            this.props.listsACLoaded && ( // Abel
              <FormControl
                style={{ marginTop: 20, marginBottom: 5, width: "100%" }}
              >
                <InputLabel htmlFor="bracket-size">
                  Voeg inschrijvingen toe aan lijst ActiveCampaign
                </InputLabel>
                <Select
                  value={this.props.tournament.listIdAC || ""}
                  onChange={this.props.handleListACChange}
                >
                  <MenuItem value={""}>
                    <i>Geen</i>
                  </MenuItem>
                  {Object.keys(this.props.listsAC).map((key) => {
                    let name = this.props.listsAC[key];
                    return (
                      <MenuItem key={key} value={key}>
                        {name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
        </div>
      </div>
    );
  }
}
